import React from 'react';

const PolicyCardDecoration = ({ color }) => (
  <svg
    viewBox="0 0 334 117"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    }}
  >
    {/* Large blob */}
    <circle cx="60.5" cy="96.5" r="149.5" fill={color} fillOpacity="0.1" />

    {/* Concentric rings bottom-left */}
    {[31.5, 30, 28.5, 27, 25.5, 24, 22.5, 21, 19.5, 18, 16.5].map((r, i) => (
      <circle
        key={i}
        cx="31.5"
        cy="106.5"
        r={r}
        stroke={color}
        strokeOpacity="0.3"
        strokeWidth="0.2"
      />
    ))}

    {/* Cross icon right */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M305.038 13.4177C304.259 10.4764 301.244 8.72288 298.303 9.50111L277 15.1374C274.059 15.9156 272.306 18.9309 273.084 21.8721L278.72 43.1747L257.417 48.811C254.476 49.5892 252.723 52.6044 253.501 55.5457L259.137 76.8483C259.915 79.7897 262.931 81.5431 265.872 80.7649L287.174 75.1286L292.811 96.4313C293.589 99.3726 296.604 101.126 299.545 100.348L320.848 94.7116C323.789 93.9333 325.543 90.9182 324.765 87.9768L319.128 66.6742L340.431 61.038C343.372 60.2597 345.126 57.2446 344.348 54.3032L338.711 33.0006C337.933 30.0594 334.918 28.3058 331.977 29.084L310.674 34.7203L305.038 13.4177Z"
      stroke={color}
      strokeOpacity="0.17"
      strokeWidth="7"
    />
  </svg>
);

export default PolicyCardDecoration;
